export default __webpack_public_path__ + "volvo-logo.svg";